export var FeedbackTargetTypes;
(function (FeedbackTargetTypes) {
    /**
     * Отзыв на Импульс в целом
     */
    FeedbackTargetTypes["Impulse"] = "Impulse";
    /**
     * Отзыв на проведённое событие
     */
    FeedbackTargetTypes["SportEvent"] = "SportEvent";
})(FeedbackTargetTypes || (FeedbackTargetTypes = {}));
